import { Link } from "react-router-dom";
// import img from "../../../../assets/images/paysuccess.png";
import { Icon } from "@iconify/react/dist/iconify.js";
// import "./style.css";
import useStyles from "../../styles";

const PaymentDeclined = () => {
  const classes = useStyles();

  return (
    <div className="pay-redirect">
      <div className={classes.paymentdeclined}>
        <Icon icon="line-md:cancel" width="120" height="120" style={{ color: "#D70654" }} />
        <p>Payment Declined</p>
        <span>Unfortunately, your payment was declined. Please check your payment details and try again.</span>
        <Link to="/auth/login">Retry</Link>
      </div>
    </div>
  );
};

export default PaymentDeclined;
